export default {
  Decision: 1,
  ReportEvidence: 2,
  DocumentExtractEvidence: 3,
};
